import { ReactComponent as logo } from "./logo.svg";
import { ReactComponent as discord } from "./discord.svg";
import { ReactComponent as twitter } from "./twitter.svg";
import { ReactComponent as telegram } from "./telegram.svg";
import { ReactComponent as youtube } from "./youtube.svg";
import { ReactComponent as cart } from "./cart.svg";
import { ReactComponent as language } from "./language.svg";
import { ReactComponent as arrow } from "./arrow-down.svg";
import { ReactComponent as appstore_qr } from "./appstore-qr.svg";
import { ReactComponent as google_qr } from "./google-qr.svg";
import { ReactComponent as google } from "./google-play.svg";
import { ReactComponent as appstore } from "./appstore.svg";
import { ReactComponent as sign } from "./sign.svg";
import { ReactComponent as arrow_up } from "./arrow-up.svg";
import { ReactComponent as arrow_down } from "./arrow-dw.svg";
import { ReactComponent as arrow_default } from "./default-arrow.svg";
import { ReactComponent as unqork } from "./unqork.svg";
import { ReactComponent as visa } from "./visa.svg";
import { ReactComponent as ness } from "./ness.svg";
import { ReactComponent as safety_wing } from "./safety-wing.svg";
import { ReactComponent as identity } from "./identity.svg";
import { ReactComponent as stitch } from "./stitch.svg";
import { ReactComponent as okra } from "./okra.svg";
import { ReactComponent as vital } from "./vital.svg";
import { ReactComponent as resly } from "./resly.svg";
import { ReactComponent as humaans } from "./humaans.svg";
import { ReactComponent as geo } from "./geo.svg";
import { ReactComponent as mail } from "./mail.svg";
import { ReactComponent as doughnut } from "./doughnut.svg";
import { ReactComponent as coin } from "./coin.svg";
import { ReactComponent as line } from "./line.svg";
import { ReactComponent as line1 } from "./line1.svg";

export const ICONS = {
	logo,
	discord,
	twitter,
	telegram,
	youtube,
	cart,
	language,
	arrow,
	appstore_qr,
	google_qr,
	google,
	appstore,
	sign,
	arrow_up,
	arrow_down,
	arrow_default,
	unqork,
	visa,
	ness,
	safety_wing,
	identity,
	stitch,
	okra,
	vital,
	resly,
	humaans,
	geo,
	mail,
	doughnut,
	line,
	coin,
	line1,
} as const;

export type IconNames = keyof typeof ICONS;
